/* src/app/shared/components/ship-details/ship-details.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.ship-details {
  position: relative;
  font-size: 1rem;
  padding: 1rem;
}
@media screen and (min-width: 48rem) {
  .ship-details {
    padding: 0;
  }
}
@media screen and (min-width: 48rem) {
  .ship-details .ship-details-content {
    padding: 5em 2em;
    max-width: 75rem;
  }
}
.ship-details .summary {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  position: relative;
}
@media screen and (min-width: 48rem) {
  .ship-details .summary {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    justify-content: space-between;
    max-width: 50rem;
    column-gap: 3rem;
  }
}
.ship-details .summary.expanded .no-print {
  max-width: 100%;
}
@media screen and (min-width: 48rem) {
  .ship-details .summary.expanded .no-print .section-content {
    max-width: 47%;
  }
}
@media screen and (min-width: 48rem) {
  .ship-details .summary.expanded .score-card {
    position: absolute;
    right: 0;
    top: 0;
    transform: translateY(-4rem);
  }
}
.ship-details .summary .summary-section {
  flex: 1;
  transition: all 0.7s ease-in-out;
}
@media screen and (min-width: 48rem) {
  .ship-details .summary .summary-section {
    width: 50%;
    max-width: 24rem;
  }
}
.ship-details .summary .summary-section.score-card {
  background-color: white;
  transition: all 0.7s ease-in-out;
}
.ship-details .tracking-details-table {
  position: relative;
  visibility: hidden;
  opacity: 0;
  max-height: 0;
  transition: all 0.3s ease-in-out;
}
.ship-details .tracking-details-table.visible {
  visibility: visible;
  opacity: 1;
  min-height: 5em;
  max-height: 25em;
  overflow-y: auto;
}
.ship-details .tracking-details-table.visible .dataTables_wrapper {
  padding: 0;
}
.ship-details .section.shipment-details,
.ship-details .section.shipment-information {
  width: 100%;
}
.ship-details .general-shipment-info {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
  max-width: 50rem;
}
.ship-details .tracked-shipment-info {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  flex-wrap: wrap;
  column-gap: 3rem;
  max-width: 50rem;
}
.ship-details .tracked-shipment-info > .tracked-shipment-info-section {
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .ship-details .tracked-shipment-info > .tracked-shipment-info-section.special-services {
    width: 45%;
    max-width: 47%;
  }
}
@media screen and (min-width: 64rem) {
  .ship-details .tracked-shipment-info > .tracked-shipment-info-section {
    flex: 1;
  }
}
.ship-details .commodities .content-items {
  min-width: 45%;
  max-width: 47%;
}
.ship-details .commodities ::ng-deep .dataTables_wrapper {
  padding: 0;
}
.ship-details .commodities .footer {
  font-weight: 700;
  background-color: white !important;
}
.ship-details .commodities .footer td {
  font-size: 1rem !important;
  color: rgba(0, 0, 0, 0.87) !important;
  border-top: 1px solid #111111;
}
.ship-details .section {
  margin-bottom: 3em;
}
.ship-details .section.shipment-status .content-items .content-item.handheld-signature {
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
}
.ship-details .section.shipment-status .content-items .content-item.handheld-signature .signature-image img {
  width: auto;
  height: auto;
}
.ship-details .section.shipment-status .content-items .content-item.handheld-signature .signature-caption {
  font-size: 0.6875em;
}
.ship-details .section.tracking-details .section-content .content-items {
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .ship-details .section.tracking-details .section-content .content-items .content-item .value {
    flex-grow: 1;
  }
}
.ship-details .section.tracking-details .section-content .content-items .content-item .value .link {
  margin: 0 1em;
}
.ship-details .section.restricted-zip-code {
  padding: 0;
  margin-top: 0;
}
@media screen and (min-width: 48rem) {
  .ship-details .section.restricted-zip-code {
    margin-top: -4em;
  }
}
.ship-details .section.notifications .notification {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border: solid thin #e8e8e6;
  border-radius: 3px;
  padding: 1.25rem 1.25rem 1.25rem 0.90625rem;
  font-size: 0.75rem;
  margin-bottom: 2em;
  line-height: 1.5;
}
.ship-details .section.notifications .notification::before {
  margin-right: 0.78125rem;
  width: 1.375rem;
  height: 1.375rem;
  zoom: 1.5;
}
.ship-details .section.notifications .notification.alert {
  color: #d50000;
  border-color: #d50000;
}
.ship-details .section.notifications .notification.alert::before {
  content: url("./media/alert.svg");
}
.ship-details .section.notifications .notification .notification-content {
  font-size: 0.75rem;
}
.ship-details .section.notifications .notification .notification-content h5,
.ship-details .section.notifications .notification .notification-content h6,
.ship-details .section.notifications .notification .notification-content .mat-mdc-checkbox,
.ship-details .section.notifications .notification .notification-content p {
  font-size: 1em;
}
.ship-details .section.notifications .notification .notification-content h5,
.ship-details .section.notifications .notification .notification-content h6 {
  margin-top: 0;
}
.ship-details .section.notifications .notification .notification-content p {
  margin-bottom: 0;
}
.ship-details .section.notifications .notification .mat-mdc-form-field-error {
  margin-top: 1em;
}
.ship-details .section.notifications .reroute p {
  margin-top: 1em;
}
.ship-details .section.notifications p {
  font-size: 0.8em;
}
.ship-details .section.payment-bill-to .content-items .content-item.bill-to {
  margin: 10px 0 2.6em 0;
  padding-top: 0;
}
.ship-details .section.total-payment {
  margin-top: -3em;
}
.ship-details .section.total-payment .content-items .content-item .key {
  width: 13em;
}
.ship-details .section.total-payment .content-items .content-item .value {
  width: 8em;
}
.ship-details .section.total-payment .content-items .content-item.total {
  border-top: 2px solid #d9d9d6;
  font-weight: 700;
  padding-top: 1em;
  margin-top: 1em;
}
.ship-details .section.total-payment .content-items .content-item.total .key {
  text-align: right;
  padding-right: 2em;
}
.ship-details .section-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0.5rem 0 1.125rem 0;
  width: 20.125rem;
}
.ship-details .section-header .section-title {
  font-family: "Roboto Flex", sans-serif;
  color: rgba(36, 36, 36, 0.87);
  margin: 0;
  font-size: 1.125em;
  font-weight: 600;
}
.ship-details .section-header .shipment-edit {
  color: #004791;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.8125rem;
}
.ship-details .section-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  flex-wrap: wrap;
  font-size: 0.875em;
  column-gap: 3rem;
}
@media screen and (min-width: 48rem) {
  .ship-details .section-content {
    flex-direction: row;
  }
}
.ship-details .section-content .content-items {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 1em;
}
@media screen and (min-width: 48rem) {
  .ship-details .section-content .content-items {
    width: 100%;
    align-items: stretch;
  }
}
.ship-details .section-content .content-items.shipment-details {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  column-gap: 3rem;
}
@media screen and (min-width: 48rem) {
  .ship-details .section-content .content-items.shipment-details {
    flex-direction: row;
    width: 100%;
  }
}
.ship-details .section-content .content-items.shipment-details .content-items-left,
.ship-details .section-content .content-items.shipment-details .content-items-right {
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .ship-details .section-content .content-items.shipment-details .content-items-left,
  .ship-details .section-content .content-items.shipment-details .content-items-right {
    flex: 1;
  }
}
@media screen and (min-width: 64rem) {
  .ship-details .section-content .content-items.shipment-information {
    flex: 1;
    min-width: 45%;
    max-width: 47%;
  }
}
.ship-details .section-content .content-items.payment-information {
  align-items: stretch;
  justify-content: flex-start;
}
.ship-details .section-content .content-items.payment-information .content-item .key {
  width: 13em;
}
.ship-details .section-content .content-items.payment-information .content-item.schedule-pickup .key {
  font-weight: 700;
}
.ship-details .section-content .content-items .content-items-title {
  font-family: "Roboto Flex", sans-serif;
  font-weight: 700;
  align-self: flex-start;
}
.ship-details .section-content .content-items .content-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.5em 0;
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .ship-details .section-content .content-items .content-item.break {
    flex-basis: 100%;
    width: 0;
    height: 0;
    overflow: hidden;
  }
}
.ship-details .section-content .content-items .content-item .key,
.ship-details .section-content .content-items .content-item .value {
  flex: 1 1 auto;
}
.ship-details .section-content .content-items .content-item .value {
  font-weight: 700;
  white-space: unset;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  max-width: 60%;
  word-break: break-word;
}
.ship-details .section-content .content-items .content-item .value a {
  line-height: 1;
}
@media screen and (min-width: 48rem) {
  :host-context(.ups-dialog) .ship-details .section-content .content-items.shipment-details .content-item {
    margin-right: 2rem;
  }
}
.only-print {
  display: none;
}
@media print {
  .only-print {
    display: block;
  }
}
/*# sourceMappingURL=ship-details.component.css.map */
